import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import * as bookingActions from '../../../store/actions/booking.action';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  admins = [
    'enoch@abassey.com',
    'maseko@bongane.com',
    'kabelo.ndlovu1@gmail.com',
    'charles@asante.com',
    'maseko.iaggauteng@vodamail.co.za',
    'casante@charlitex.com',

    // Hospitality team
    'mathole.pa@gracebiblechurch.org.za',
    'thuli.mageba@gmail.com',
    'admin@e21africa.co.za'
  ];
  isAdmin: boolean;
  user$;
  constructor(
    public authService: AuthService,
    public router: Router,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.user$ = this.authService.user;

    this.authService.user
      .pipe(
        map(auth => {
          if (auth) {
            return this.admins.includes(auth.email);
          }
        })
      )
      .subscribe(value => (this.isAdmin = value));
  }

  viewAddNewBooking() {
    // this.store.dispatch(new bookingActions.GoToAddBookingView());
    this.router.navigate(['/bookings/add']);
  }

  logout() {
    this.router.navigate(['/home']).then(() => {
      this.authService.logout();
    });
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/header/header.component.ts